export enum SortDirection {
    asc = 'asc',
    desc = 'desc',
}

export function toUpperCase(sortDirection: SortDirection) {
    return sortDirection === 'asc' ? 'ASC' : 'DESC';
}

export function toLowerCase(sortDirection: SortDirection) {
    return sortDirection === 'asc' ? 'asc' : 'desc';
}
